.hero {
  background: var(--bg-dark);
  color: var(--text-on-dark);
  padding: 12px 16px 18px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.heroTop {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 16px;
}

.title {
  margin: 0;
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 34px;
  line-height: 1;
  text-transform: uppercase;
}

.form {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
}

.searchField {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 50px;
  padding: 0 14px;
  border-radius: var(--r-12);
  background: var(--bg-panel);
  color: var(--text-muted);
}
.searchInput {
  flex-grow: 1;
  min-width: 0;
  height: 46px;
  border: 0;
  outline: none;
  font-size: 16px;
  color: var(--text-primary);
  background: transparent;
}

.locationRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.locationButton {
  height: 44px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 12px 0 10px;
  border-radius: var(--r-pill);
  border: 1px solid #3a3e44;
  background: var(--bg-dark-panel);
  color: var(--text-on-dark);
  font-size: 14px;
  font-weight: 600;
}

.eventCount {
  font-size: 13px;
  color: var(--text-on-dark-faint);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.whenSelect {
  height: 52px;
  padding: 0 12px;
  border-radius: var(--r-12);
  border: 1px solid #3a3e44;
  background: var(--bg-dark-panel);
  color: var(--text-on-dark);
  font-size: 15px;
  font-weight: 600;
}

.submit {
  height: 52px;
  border-radius: var(--r-12);
  border: 0;
  background: var(--accent-strong);
  color: var(--text-on-dark);
  font-size: 18px;
  font-weight: 700;
}

.locationPopover {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  z-index: 20;
  width: 300px;
  background: var(--bg-panel);
  color: var(--text-primary);
  border-radius: var(--r-12);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.25);
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.locationWrap {
  position: relative;
}
.locationUseMine {
  height: 40px;
  border-radius: var(--r-8);
  border: 1px solid var(--border-4);
  background: var(--bg-page);
  color: var(--text-primary);
  font-weight: 600;
  font-size: 14px;
}
.locationManualRow {
  display: grid;
  grid-template-columns: 1fr 90px;
  gap: 8px;
}
.locationManualInput,
.locationRadiusSelect {
  height: 40px;
  padding: 0 10px;
  border-radius: var(--r-8);
  border: 1px solid var(--border-4);
  font-size: 14px;
}
.locationApply {
  height: 40px;
  border-radius: var(--r-8);
  border: 0;
  background: var(--accent-strong);
  color: #fff;
  font-weight: 700;
  font-size: 14px;
}
.locationError {
  font-size: 13px;
  color: var(--danger);
}

@media (min-width: 1200px) {
  .hero {
    padding: 28px 24px 32px;
  }
  .title {
    font-size: 48px;
  }
  .form {
    /* 3 tracks, not 4 - LocationPicker (the old 280px track) is hidden while
       SearchBar.tsx's SHOW_LOCATION_SEARCH flag is off. Search field fills all the
       freed-up space instead of leaving a dead gap, and Search stays flush right since
       the grid has no leftover track past it. */
    grid-template-columns: 1fr 200px 140px;
  }
  .searchField {
    height: 52px;
  }
  .searchInput {
    height: 48px;
  }
  .locationButton {
    height: 52px;
    width: 100%;
    justify-content: flex-start;
  }
}
